import { render, staticRenderFns } from "./ConversionSection.vue?vue&type=template&id=229d8e04&scoped=true"
import script from "./ConversionSection.vue?vue&type=script&lang=js"
export * from "./ConversionSection.vue?vue&type=script&lang=js"
import style0 from "./ConversionSection.vue?vue&type=style&index=0&id=229d8e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d8e04",
  null
  
)

export default component.exports